// прибиваем id склада на фронте по решению Ирины Нефедовой, подробнее в задаче:
// https://youtrack.wildberries.ru/issue/SPL-2682
import i18next from 'i18next';
import { WAREHOUSES_LIMITS_PAGE_TRANSLATIONS } from '@/pages/supplies-management/children/warehouses-limits/_constants/translations';

export const WAREHOUSE_ID_ALL = -1;
export const WAREHOUSE_FILTER_ALL = {
  label: i18next.t(WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.all),
  id: i18next.t(WAREHOUSES_LIMITS_PAGE_TRANSLATIONS.all),
  value: WAREHOUSE_ID_ALL,
};
export const WAREHOUSES_FILTERS = 'WAREHOUSES_FILTERS';
export const WAREHOUSES_LIMITS_UP_TO_DAY = 7;
